import platform from '@/shared/utils/platform';
import RouterHelper from '@/shared/utils/routerHelper';
import { RouterV2Enum, RouterV3Enum } from './router-names';

// 根据环境返回当前home路由
export const getHomePath = (): string => (
  (platform.isAlipayMini || platform.isDingTalk) ? RouterV2Enum.aliminiHome : RouterV2Enum.home);

// 尝试返回到指定的历史路由，如果不存在以首页备份
export const tryBackPathOrHome = (path: string): RouterV2Enum | string => {
  const { historyStates } = RouterHelper;

  for (let index = historyStates.length - 1; index >= 0; index -= 1) {
    const stateData = historyStates[index];

    if (
      stateData.paths
      && stateData.paths.length
      && stateData.paths[stateData.paths.length - 1].startsWith(path)
    ) {
      return path;
    }
  }

  return getHomePath();
};

/** 首页所有版本路由 */
export const HOME_ALL_VERSION_ROUTE_PATHS = [
  RouterV2Enum.home,
  RouterV2Enum.taglessHome,
  RouterV2Enum.qualityHomePage,
  RouterV3Enum.home,
];
